export function decodeHtmlEntities(text: string): string {
  return text.replace(ENTITY, (entity) => CHARACTERS[entity] ?? entity);
}

const CHARACTERS: Readonly<Record<string, string>> = {
  "&gt;": ">",
  "&lt;": "<",
  "&amp;": "&",
  "&quot;": '"',
  "&#39;": "'",
};

const ENTITY = /&(?:gt|lt|amp|quot|#39);/g;
